import React, { useEffect, useState } from 'react';

import { Slider as PrimeReactSlider, SliderProps } from 'primereact/slider';

type CustomSliderProps = SliderProps & {
    onSelect?:(value: any) => void;
}

const Slider: React.FC<CustomSliderProps> = (props): JSX.Element => {
    const { min, onSelect, ...passThroughProps } = props;

    const [minimal, setMinimal] = useState(0);

    useEffect(() => {
        setTimeout(() => {
            setMinimal(min);
        }, 500);
    }, [min]);

    const handleChange = (e) => {
        if (e.originalEvent.type === 'click') {
            onSelect(e.value);
        }

        if (passThroughProps.onChange) {
            passThroughProps.onChange(e);
        }
    }

    return (
        <PrimeReactSlider
            {...passThroughProps}
            step={1000}
            min={minimal}
            onChange={(e) => handleChange(e)}
        />
    );
}

export default Slider;
